import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText, IonDatetime } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect} from 'react';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

import { Preferences } from '@capacitor/preferences';

//import  firebase from 'firebase/compat/app';
import { initializeApp } from 'firebase/app';
//import { getMessaging } from 'firebase/messaging';
import { PushNotifiPushNotificationSchema, PushNotifications, Token, ActionPerformed } from '@capacitor/push-notifications';



async function setFcmToken(event) {

  Preferences.set({
      key: 'fcm_token',
      value: event,
  })
  
}

export function Push_Notification(props) {


    let authenticatedMerchent_context = useContext(Auth_Zasava_Context);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);





    useEffect(() => {
      // Request notification permission

      const firebaseConfig = {
          apiKey: "AIzaSyBWhLS76gaww1Szv_hx9EQYYCwlfigQzBQ",
          authDomain: "ghanaverified-98187.ghanaverified.com",
          projectId: "ghanaverified-98187",
          storageBucket: "ghanaverified-98187.firebasestorage.app",
          messagingSenderId: "496948390277",
          appId: "1:496948390277:android:b3953c504f534666b0fcec",
          measurementId: ""
      };

      const firebaseApp = initializeApp(firebaseConfig);

      //const messaging = getMessaging(firebaseApp);

      PushNotifications.requestPermissions().then(result => {
        if (result.receive === 'granted') {
          // Register for push notifications
          PushNotifications.register();
        } else {
          alert('Push notification permission not granted');
        }
      });


      PushNotifications.addListener('registration', (token) => {
          //alert('FCM Token:', token.value);
          setFcmToken(token.value); // Store token
          authenticatedMerchent_context.changeFcmToken(token.value);
          sendFcmTokenToBackend(token.value); // Send the refreshed token to backend

        });


        PushNotifications.addListener('registrationRefresh', (token) => {
          alert('FCM Token refreshed:', token.value);
          setFcmToken(token.value); // Update the token
          authenticatedMerchent_context.changeFcmToken(token.value);
          sendFcmTokenToBackend(token.value); // Send the refreshed token to backend
        });


      // Handle incoming push notifications
      PushNotifications.addListener('pushNotificationReceived', notification => {
          alert('Notification received: - '+ notification);
          alert(notification.title);
          alert(notification.body);

          props.setNotificationData('Notification received: - '+ notification);
          props.setNotificationData(notification.title);
          props.setNotificationData(notification.body);

      });
  
      
      // Handle notification action (when the notification is tapped)
      PushNotifications.addListener('pushNotificationActionPerformed', action => {
        alert('Notification action performed:', action);
      });

    }, []);


     function sendFcmTokenToBackend(event)
     {

        //alert('In sendFcmTokenToBackend');
        //alert(event);
        //alert(window.location.origin);

         let formData = new FormData();
         formData.append('fcmToken', event);
        //  formData.append('user', acctID);
        //  formData.append('xJobRequisitionID', props.data.requisitionID);
        //  formData.append('xJobApplicationID', props.data.applicationID);
        //  formData.append('xApplicantMobileNumber', applicant_phoneNumber);
        //  formData.append('sessionID', sessionID);
 
 
         const requestOptions = {
             enctype: 'multipart/form-data',
             method:'POST',
             credentials: 'include',
             files: formData,
             body: formData,
             contentType: false,
             processData: false,
         }
         
 
         fetch(window.location.origin+'/save_fcm_token', requestOptions)
         .then(res => res.text())
         .then(data => {
 
             alert(data);
              
         })
         .catch(error => {
             console.error(error);
         })
     }


    return (

        <React.Fragment>

        </React.Fragment>

    )
    //}   
}